import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Apis
import { DictKeyApi } from '@core/api/app/dict-key.api';

// Models
import { DictKeyEntry, DictKeyEntryResponse } from '@core/models/app/dict-key.model';

/**
 * Service d'édition inline des entrées du dictionnaire (dev-mode).
 * Distinct de `DictKeyService`, qui n'écoute que le DOM et ne fait aucun appel réseau.
 */
@Injectable({ providedIn: 'root' })
export class DictKeyEditService {
	constructor(private api: DictKeyApi) {}

	getEntry(field: string): Observable<DictKeyEntryResponse> {
		return this.api.getEntry(field);
	}

	saveEntry(entry: DictKeyEntry): Observable<unknown> {
		return this.api.saveEntry(entry);
	}
}
